import { render } from "./InputListSelector.vue?vue&type=template&id=6b61aba1&scoped=true"
import script from "./InputListSelector.vue?vue&type=script&lang=js"
export * from "./InputListSelector.vue?vue&type=script&lang=js"

import "./InputListSelector.vue?vue&type=style&index=0&id=6b61aba1&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6b61aba1"

export default script